import React from "react";
import { Box, CircularProgress, Skeleton, Typography } from "@mui/material";

interface PermissionLoadingStateProps {
  variant?: "page" | "inline" | "skeleton";
  message?: string;
}

/**
 * Loading state component for permission checks
 * Provides better UX while checking permissions
 */
export const PermissionLoadingState: React.FC<PermissionLoadingStateProps> = ({
  variant = "page",
  message = "Tarkistetaan käyttöoikeuksia...",
}) => {
  if (variant === "skeleton") {
    return (
      <Box sx={{ width: "100%" }}>
        <Skeleton variant="text" width="60%" height={40} sx={{ mb: 2 }} />
        <Skeleton
          variant="rectangular"
          width="100%"
          height={200}
          sx={{ mb: 2 }}
        />
        <Box sx={{ display: "flex", gap: 2 }}>
          <Skeleton variant="rectangular" width="30%" height={100} />
          <Skeleton variant="rectangular" width="30%" height={100} />
          <Skeleton variant="rectangular" width="30%" height={100} />
        </Box>
      </Box>
    );
  }

  if (variant === "inline") {
    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          py: 1,
        }}
      >
        <CircularProgress size={16} />
        <Typography variant="body2" color="text.secondary">
          {message}
        </Typography>
      </Box>
    );
  }

  // Default: page variant
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "60vh",
        gap: 2,
      }}
    >
      <CircularProgress size={40} />
      <Typography variant="body1" color="text.secondary">
        {message}
      </Typography>
    </Box>
  );
};
